import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Grid,
  Button,
} from '@material-ui/core'
import { 
  Add as AddIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  GetApp as GetAppIcon,
 } from '@material-ui/icons'

import { mdiPencil } from '@mdi/js'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import history from '~/helpers/history'

import { Creators as CircularsActions } from '~/store/ducks/circulars'

import Portlet from '~/components/Portlet'
import ListFooter from '~/components/ListFooter'
import ConfirmDialog from '~/components/ConfirmDialog'
import CustomIcon from '~/components/CustomIcon'
import { useSmallScreen } from '~/helpers/useMediaQuery'
import OverlayLoading from '~/components/OverlayLoading'
import EmptyList from '~/components/EmptyList'
import styles from './styles'
import ViewCircularDialog from './components/ViewCircularDialog'

const circularsSelector = ({ circulars }) => circulars

const useStyles = makeStyles(styles)

function CircularsPage() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openConfirmDialog, setConfirmDialog] = useState(false)

  const [circularId, setCircularId] = useState(null)
  const { data, options, loading } = useSelector(circularsSelector)
  const [openViewCircularDialog, setOpenViewCircularDialog] = useState(false)

  const isSmallScreen = useSmallScreen()
  useEffect(() => {
    dispatch(CircularsActions.getCircularsRequest())
  }, [])

  const handleChangeRowsPerPage = (ev) => {
    const {
      target: { value },
    } = ev
    dispatch(CircularsActions.setCircularsPage(0, value))
  }

  const handleChangePage = (_, page) => {
    dispatch(CircularsActions.setCircularsPage(page, options.limit))
  }

  const handleRemoveCircular = (id) => {
    setCircularId(id)
    setConfirmDialog(true)
  }

  const handleEditCircular = (id) => {
    history.push(`/circulars/${id}`)
  }

  const handleRemoveCancel = () => {
    setCircularId(null)
    setConfirmDialog(false)
  }

  const handleRemoveAccept = () => {
    dispatch(
      CircularsActions.removeCircularRequest(circularId, () => {
        dispatch(CircularsActions.getCircularsRequest())
        setCircularId(null)
        setConfirmDialog(false)
      }),
    )
  }

  const handleViewCircular = (id) => {
    setCircularId(id)
    setOpenViewCircularDialog(true)
  }

  const handleDownloadCircular = (url) => {
    window.open(url, '_blank')
  }

  const handleCloseViewCircularDialog = () => {
    setOpenViewCircularDialog(false)
    setCircularId(null)
    history.push('/circulars')
  }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          justifyContent="flex-end"
          className={classes.gridContainerButton}
        >
          <Grid item style={{ paddingTop: isSmallScreen ? 8 : '' }}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonAdd}
              // disabled
              onClick={() => history.push('circulars/new')}
            >
              <AddIcon className={classes.iconAdd} /> Adicionar Circular
            </Button>
          </Grid>
        </Grid>
        <Portlet className={classes.grow}>
          <div className={classes.tableWrapper}>
            {!loading && data.length === 0 && (
              <EmptyList message="Não há circulares para serem visualizadas" />
            )}
            {loading && <OverlayLoading />}
            {!loading && (
              <div className={classes.listWrapper}>
                {data.length > 0 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Data de cadastro</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((item) => (
                        <TableRow
                          hover
                          key={item.id}
                          className={classes.tableRow}
                        >
                          <TableCell>{item.name || '-'}</TableCell>
                          <TableCell>{item.status_description || '-'}</TableCell>
                          <TableCell>
                            {moment(item.created_at || '-').format(
                              'DD/MM/YYYY HH:mm',
                              'HH/MM',
                            )}
                          </TableCell>
                          <TableCell align="right">
                            <div className={classes.tableCellActions}>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() => handleViewCircular(item.id)}
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() =>
                                  handleDownloadCircular(item.url_pdf_file)
                                }
                              >
                                <GetAppIcon />
                              </IconButton>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() => handleEditCircular(item.id)}
                              >
                                <CustomIcon pathComponent={mdiPencil} />
                              </IconButton>
                              <IconButton
                                className={classes.visibilityIcon}
                                onClick={() => handleRemoveCircular(item.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </div>
            )}
          </div>

          {data.length > 0 && (
            <ListFooter
              options={options}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              onChangePage={handleChangePage}
            />
          )}
        </Portlet>
      </div>

      <ViewCircularDialog
        id={circularId}
        open={openViewCircularDialog}
        onClose={handleCloseViewCircularDialog}
      />

      <ConfirmDialog
        open={openConfirmDialog}
        title="Atenção"
        description="Deseja realmente excluir esta circular?"
        onCancel={handleRemoveCancel}
        onAccept={handleRemoveAccept}
      />
    </>
  )
}

export default CircularsPage
